// extracted by mini-css-extract-plugin
module.exports = {"table-match-wrapper":"TableMatch_table-match-wrapper__-6rRR"};